(function () {
  var cfg = window.slpCtConfig || {};
  var queue = (window.__slpCtQueue = window.__slpCtQueue || []);
  var seenViews = {};
  var pageLoadId = "";
  var UTM_STORE = "slp_utm";
  var PIN_COOKIE = "pincode";
  var SESSION_KEYS = ["session_id", "sessionId", "sid"];
  var FP_KEYS = ["fingerprint", "fp", "device_fingerprint", "visitor_id"];
  var PIN_KEYS = ["pincode", "pin_code", "user_pincode", "slp_pincode"];

  var SECTIONS = [
    [".slp-header", "slp_header", 0],
    [".slp-hero", "slp_hero", 0],
    ["[data-slp-authored]", "slp_authored", 0],
    ["[data-slp-why]", "slp_why", ".slp-why__card"],
    ["[data-slp-services]", "slp_all_services", ".slp-services__card"],
    ["[data-slp-mechanics]", "slp_mechanics", "[data-slp-mech-card]"],
    ["[data-slp-reviews]", "slp_reviews", ".slp-reviews__card"],
    ["[data-slp-how]", "slp_how", ".slp-how__card"],
    ["[data-slp-pricing]", "slp_pricing", ".slp-pricing__table tbody tr"],
    ["[data-slp-faq]", "slp_faq", ".slp-faq__item"],
    ["[data-slp-qa]", "slp_qa", "[data-slp-qa-card]"],
    ["[data-slp-refs]", "slp_references", ".slp-refs__item"],
    ["[data-slp-social]", "slp_social", 0],
    ["[data-slp-feedback]", "slp_feedback", 0],
    ["[data-slp-footer]", "slp_footer", ".slp-footer__chip"],
  ];

  function readCookie(name) {
    var parts = ("; " + document.cookie).split("; " + name + "=");
    if (parts.length < 2) return "";
    return decodeURIComponent(parts.pop().split(";").shift() || "").trim();
  }

  function firstCookie(names) {
    for (var i = 0; i < names.length; i++) {
      var v = readCookie(names[i]);
      if (v) return v;
    }
    return "";
  }

  function storageGet(keys) {
    var stores = [];
    try {
      stores.push(window.sessionStorage);
    } catch (e1) {}
    try {
      stores.push(window.localStorage);
    } catch (e2) {}
    for (var s = 0; s < stores.length; s++) {
      for (var i = 0; i < keys.length; i++) {
        var v = stores[s].getItem(keys[i]);
        if (v) return v;
      }
    }
    return "";
  }

  function persistUtmsFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var utm = {};
    [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
    ].forEach(function (key) {
      var val = params.get(key);
      if (val) utm[key] = val;
    });
    if (!Object.keys(utm).length) return;
    try {
      window.sessionStorage.setItem(UTM_STORE, JSON.stringify(utm));
    } catch (e) {}
  }

  function readUtms() {
    persistUtmsFromUrl();
    var params = new URLSearchParams(window.location.search);
    var utm = {};
    [
      "utm_source",
      "utm_medium",
      "utm_campaign",
      "utm_term",
      "utm_content",
    ].forEach(function (key) {
      var val = params.get(key);
      if (val) utm[key] = val;
    });
    if (Object.keys(utm).length) return utm;
    try {
      var stored = window.sessionStorage.getItem(UTM_STORE);
      return stored ? JSON.parse(stored) : {};
    } catch (e) {
      return {};
    }
  }

  function platform() {
    var mobile =
      window.innerWidth < 750 ||
      /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent || "");
    return mobile ? "mweb" : "web";
  }

  function compact(obj) {
    var out = {};
    Object.keys(obj).forEach(function (key) {
      var val = obj[key];
      if (val === undefined || val === null || val === "") return;
      out[key] = val;
    });
    return out;
  }

  function cleanText(el) {
    if (!el) return "";
    return (el.getAttribute("aria-label") || el.textContent || "")
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, 160);
  }

  function indexIn(el, selector, root) {
    var scope = root || el.closest("[data-ct-section]") || document;
    var list = scope.querySelectorAll(selector);
    for (var i = 0; i < list.length; i++) {
      if (list[i] === el || list[i].contains(el)) return String(i + 1);
    }
    return "";
  }

  function commonPayload() {
    var page = cfg.page || {};
    var utm = readUtms();
    var payload = {
      pincode: firstCookie(PIN_KEYS) || storageGet(PIN_KEYS),
      platform: platform(),
      source: window.location.href,
      page_name: page.name || "slp_service_location",
      page_load_id: pageLoadId,
      session_id: firstCookie(SESSION_KEYS) || storageGet(SESSION_KEYS),
      timestamp: new Date().toISOString(),
      fingerprint: firstCookie(FP_KEYS) || storageGet(FP_KEYS),
      referrer: document.referrer || "",
      service: page.service || "",
      city: page.city || "",
      locality: page.locality || "",
    };
    Object.keys(utm).forEach(function (key) {
      payload[key] = utm[key];
    });
    return compact(payload);
  }

  function firePageLoad() {
    if (pageLoadId) return pageLoadId;
    pageLoadId = "pageLoad_" + Date.now();
    sendToCT("page_load", {
      page_load_id: pageLoadId,
      element_unique_name: "slp_page",
      element_name: "slp_page",
    });
    return pageLoadId;
  }

  function fireUnverifiedLead(extra) {
    extra = extra || {};
    var phone = String(extra.phone || "")
      .replace(/\D/g, "")
      .slice(-10);
    if (!phone) return null;
    return sendToCT(
      "unverified_lead",
      compact({
        phone: phone,
        mobile: phone,
        reason: extra.reason || "unverified",
        element_unique_name: extra.element_unique_name || "slp_hero_lead",
        element_name: extra.element_name || "slp_hero_lead",
        pincode: extra.pincode || "",
        vehicle: extra.vehicle || "",
      }),
    );
  }

  function sendToCT(eventLabel, extra) {
    if (!eventLabel) return;
    extra = extra || {};
    if (eventLabel === "element_clicked" && !extra.element_cta) {
      extra.element_cta = extra.action || "click";
    }
    var payload = compact(
      Object.assign({}, commonPayload(), extra, {
        eventLabel: eventLabel,
      }),
    );
    queue.push({ event: eventLabel, payload: payload });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventLabel }, payload));
    if (
      window.clevertap &&
      window.clevertap.event &&
      typeof window.clevertap.event.push === "function"
    ) {
      window.clevertap.event.push(eventLabel, payload);
    }
    return payload;
  }

  function setPincode(pin) {
    var value = String(pin || "").replace(/\D/g, "");
    if (value.length !== 6) return;
    document.cookie =
      PIN_COOKIE +
      "=" +
      encodeURIComponent(value) +
      "; path=/; max-age=2592000; SameSite=Lax";
    try {
      window.sessionStorage.setItem(PIN_COOKIE, value);
    } catch (e) {}
  }

  function clickDetails(t) {
    var qaCard = t.closest("[data-slp-qa-card]");
    var faqItem = t.closest(".slp-faq__item");
    var mechCard = t.closest("[data-slp-mech-card]");
    var serviceCard = t.closest(".slp-services__card");
    var details = {};

    if (t.closest(".slp-header__logo")) {
      return {
        element_unique_name: "slp_header_logo",
        element_name: "slp_header_logo",
        item_name: "logo",
      };
    }
    if (t.closest(".slp-header__cta")) {
      return {
        element_unique_name: "slp_header_call",
        element_name: "slp_header_call",
        item_name: cleanText(t),
      };
    }
    if (t.closest(".slp-header__links a")) {
      return {
        element_unique_name: "slp_header_nav",
        element_name: "slp_header_nav",
        item_name: cleanText(t),
        item_id: indexIn(
          t,
          ".slp-header__links a",
          document.querySelector(".slp-header"),
        ),
      };
    }
    if (t.closest(".slp-breadcrumbs__link")) {
      return {
        element_unique_name: "slp_hero_breadcrumb",
        element_name: "slp_hero_breadcrumb",
        item_name: cleanText(t),
      };
    }
    if (t.closest("[data-slp-send-otp-btn]")) {
      return {
        element_unique_name: "slp_hero_send_otp",
        element_name: "slp_hero_send_otp",
        item_name: cleanText(t),
      };
    }
    if (t.closest("[data-slp-verify-otp-btn]")) {
      return {
        element_unique_name: "slp_hero_verify_otp",
        element_name: "slp_hero_verify_otp",
        item_name: cleanText(t),
      };
    }
    if (t.closest("[data-slp-resend-otp]")) {
      return {
        element_unique_name: "slp_hero_resend_otp",
        element_name: "slp_hero_resend_otp",
        item_name: "Resend",
      };
    }
    if (t.closest("[data-slp-book-submit]")) {
      return {
        element_unique_name: "slp_hero_book_submit",
        element_name: "slp_hero_book_submit",
        item_name: cleanText(t) || "BOOK NOW",
      };
    }
    if (t.closest("[data-slp-pincode-btn]")) {
      return {
        element_unique_name: "slp_hero_check_availability",
        element_name: "slp_hero_check_availability",
        item_name: cleanText(t),
      };
    }
    if (t.closest("[data-slp-change-pincode]")) {
      return {
        element_unique_name: "slp_hero_change_pincode",
        element_name: "slp_hero_change_pincode",
        item_name: "Change",
      };
    }
    if (t.closest("[data-slp-book-another]")) {
      return {
        element_unique_name: "slp_hero_book_another",
        element_name: "slp_hero_book_another",
        item_name: cleanText(t),
      };
    }
    if (t.closest("[data-slp-book-now]")) {
      return {
        element_unique_name: "slp_book_now",
        element_name: "slp_book_now",
        item_name: "Book Now",
      };
    }
    if (serviceCard) {
      var svcTitle = serviceCard.querySelector(".slp-services__card-title");
      return {
        element_unique_name: "slp_all_services_card",
        element_name: "slp_all_services_card",
        item_name: cleanText(svcTitle) || cleanText(serviceCard),
        item_id: indexIn(serviceCard, ".slp-services__card"),
      };
    }
    if (t.closest(".slp-mechanics__toggle") && mechCard) {
      var mechName = mechCard.querySelector(".slp-mechanics__name");
      return {
        element_unique_name: "slp_mechanics_toggle_reviews",
        element_name: "slp_mechanics_toggle_reviews",
        item_name: cleanText(mechName),
        item_id: indexIn(mechCard, "[data-slp-mech-card]"),
      };
    }
    if (t.closest(".slp-faq__trigger") && faqItem) {
      var qEl = faqItem.querySelector(".slp-faq__question");
      return {
        element_unique_name: "slp_faq_question",
        element_name: "slp_faq_question",
        question: cleanText(qEl),
        item_name: cleanText(qEl),
        item_id: indexIn(faqItem, ".slp-faq__item"),
      };
    }
    if (t.closest("[data-slp-qa-toggle]") && qaCard) {
      var qaQ = qaCard.querySelector(".slp-qa__card-q");
      return {
        element_unique_name: "slp_qa_read_more",
        element_name: "slp_qa_read_more",
        question: cleanText(qaQ),
        item_name: cleanText(qaQ),
        item_id: indexIn(qaCard, "[data-slp-qa-card]"),
      };
    }
    if (t.closest('[data-vote="yes"]') && qaCard) {
      return {
        element_unique_name: "slp_qa_helpful_yes",
        element_name: "slp_qa_helpful_yes",
        question: cleanText(qaCard.querySelector(".slp-qa__card-q")),
        item_name: cleanText(qaCard.querySelector(".slp-qa__card-q")),
        item_id: indexIn(qaCard, "[data-slp-qa-card]"),
        action: "helpful_yes",
      };
    }
    if (t.closest('[data-vote="no"]') && qaCard) {
      return {
        element_unique_name: "slp_qa_helpful_no",
        element_name: "slp_qa_helpful_no",
        question: cleanText(qaCard.querySelector(".slp-qa__card-q")),
        item_name: cleanText(qaCard.querySelector(".slp-qa__card-q")),
        item_id: indexIn(qaCard, "[data-slp-qa-card]"),
        action: "helpful_no",
      };
    }
    if (t.closest("[data-slp-qa-open]")) {
      return {
        element_unique_name: "slp_qa_view_all",
        element_name: "slp_qa_view_all",
        item_name: cleanText(t),
      };
    }
    if (t.closest("[data-slp-qa-prev]")) {
      return {
        element_unique_name: "slp_qa_carousel_prev",
        element_name: "slp_qa_carousel_prev",
        item_name: "Previous",
      };
    }
    if (t.closest("[data-slp-qa-next]")) {
      return {
        element_unique_name: "slp_qa_carousel_next",
        element_name: "slp_qa_carousel_next",
        item_name: "Next",
      };
    }
    if (
      t.closest(".slp-qa__ask-go") ||
      t.closest('[data-slp-qa-form] button[type="submit"]')
    ) {
      return {
        element_unique_name: "slp_qa_ask_submit",
        element_name: "slp_qa_ask_submit",
        item_name: "Submit question",
      };
    }
    if (t.closest("[data-slp-qa-close]")) {
      return {
        element_unique_name: "slp_qa_drawer_close",
        element_name: "slp_qa_drawer_close",
        item_name: "Close",
      };
    }
    if (t.closest(".slp-refs__link")) {
      return {
        element_unique_name: "slp_references_link",
        element_name: "slp_references_link",
        item_name: cleanText(t),
        item_id: indexIn(t, ".slp-refs__link"),
      };
    }
    if (t.closest('[data-slp-feedback-vote="yes"]')) {
      return {
        element_unique_name: "slp_feedback_yes",
        element_name: "slp_feedback_yes",
        item_name: "Yes Helpful",
      };
    }
    if (t.closest('[data-slp-feedback-vote="no"]')) {
      return {
        element_unique_name: "slp_feedback_no",
        element_name: "slp_feedback_no",
        item_name: "Not Helpful",
      };
    }
    if (t.closest(".slp-footer__logo")) {
      return {
        element_unique_name: "slp_footer_logo",
        element_name: "slp_footer_logo",
        item_name: "logo",
      };
    }
    if (t.closest(".slp-footer__chip")) {
      return {
        element_unique_name: "slp_footer_interlink",
        element_name: "slp_footer_interlink",
        item_name: cleanText(t),
        item_id: indexIn(t, ".slp-footer__chip"),
      };
    }
    if (
      t.closest("#slp-footer-explore") ||
      (t.closest(".slp-footer__col") &&
        t.closest('[aria-labelledby="slp-footer-explore"]'))
    ) {
      return {
        element_unique_name: "slp_footer_explore",
        element_name: "slp_footer_explore",
        item_name: cleanText(t),
      };
    }
    if (t.closest('[aria-labelledby="slp-footer-support"]')) {
      return {
        element_unique_name: "slp_footer_support",
        element_name: "slp_footer_support",
        item_name: cleanText(t),
      };
    }
    if (t.closest(".slp-footer__nav-list a")) {
      return {
        element_unique_name: "slp_footer_nav",
        element_name: "slp_footer_nav",
        item_name: cleanText(t),
        item_id: indexIn(t, ".slp-footer__nav-list a"),
      };
    }
    return null;
  }

  window.sendToCT = sendToCT;
  window.slpCt = {
    sendToCT: sendToCT,
    commonPayload: commonPayload,
    setPincode: setPincode,
    firePageLoad: firePageLoad,
    fireUnverifiedLead: fireUnverifiedLead,
    getPageLoadId: function () {
      return pageLoadId;
    },
    queue: queue,
  };

  function fireSectionView(el) {
    var name = el.getAttribute("data-ct-section");
    if (!name || seenViews[name]) return;
    seenViews[name] = true;
    var cardsSel = el.getAttribute("data-ct-cards");
    var extra = {
      element_unique_name: name,
      element_name: name,
    };
    if (cardsSel) {
      extra.total_cards = el.querySelectorAll(cardsSel).length;
    }
    sendToCT("i_element_viewed", extra);
  }

  function watchViews() {
    if (!("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          fireSectionView(entry.target);
        });
      },
      { threshold: 0.01 },
    );

    SECTIONS.forEach(function (pair) {
      var el = document.querySelector(pair[0]);
      if (!el) return;
      el.setAttribute("data-ct-section", pair[1]);
      if (pair[2]) el.setAttribute("data-ct-cards", pair[2]);
      io.observe(el);
    });
  }

  function watchClicks() {
    document.addEventListener(
      "click",
      function (e) {
        var t =
          e.target && e.target.closest
            ? e.target.closest(
                "a, button, label.slp-faq__trigger, [data-ct-click], [data-slp-feedback-vote]",
              )
            : null;
        if (!t) return;
        var details = clickDetails(t);
        if (!details) return;
        sendToCT("element_clicked", details);
      },
      true,
    );
  }

  if (!cfg.enabled) return;

  function boot() {
    persistUtmsFromUrl();
    firePageLoad();
    watchViews();
    watchClicks();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
